import { makeStyles } from '@material-ui/core/styles'

const AuthorStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  profileImage: {
    width: 62,
    height: 62,
    marginRight: theme.spacing(1),
    '& > img': {
      width: '100%',
      height: '100%',
      display: 'inline-block',
      border: '2px solid #F2E5D2',
      borderRadius: '50%',
    },
  },
  writtenBy: {
    fontFamily: 'DomaineNarrow',
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
  },
  profileLink: {
    fontSize: 12,
    fontWeight: 600,
    margin: 0,
    '& a': {
      color: theme.palette.text.primary,
      textDecoration: 'underline',
    },
  },
}))
export default AuthorStyles
